import React, { createContext, useContext, useState, useCallback } from 'react';

const ADMIN_KEY = 'workwear_admin_auth';
const ADMIN_USER_KEY = 'workwear_admin_user';
export const ADMIN_USERNAME = 'superadmin';
export const ADMIN_PASSWORD = 'shLfjc999@';

const AdminContext = createContext(null);

/** 管理员权限 Context */
export function AdminProvider({ children }) {
  const [isAdmin, setIsAdmin] = useState(
    () => sessionStorage.getItem(ADMIN_KEY) === '1'
  );
  const [adminUser, setAdminUser] = useState(
    () => sessionStorage.getItem(ADMIN_USER_KEY) || ''
  );

  const unlock = useCallback((username) => {
    const user = username?.trim() || ADMIN_USERNAME;
    setIsAdmin(true);
    setAdminUser(user);
    sessionStorage.setItem(ADMIN_KEY, '1');
    sessionStorage.setItem(ADMIN_USER_KEY, user);
  }, []);

  const logout = useCallback(() => {
    setIsAdmin(false);
    setAdminUser('');
    sessionStorage.removeItem(ADMIN_KEY);
    sessionStorage.removeItem(ADMIN_USER_KEY);
  }, []);

  const verifyLogin = useCallback((username, inputPassword) => {
    if (username?.trim() === ADMIN_USERNAME && inputPassword === ADMIN_PASSWORD) {
      unlock(username.trim());
      return true;
    }
    return false;
  }, [unlock]);

  return (
    <AdminContext.Provider
      value={{
        isAdmin,
        adminUser,
        verifyLogin,
        logout,
      }}
    >
      {children}
    </AdminContext.Provider>
  );
}

export function useAdmin() {
  const ctx = useContext(AdminContext);
  if (!ctx) throw new Error('useAdmin must be used within AdminProvider');
  return ctx;
}
